<template>
	<div>
		<div class="teacher-lesson">
			<ul class="teacher-lesson-items f-cbli">
				<!--<li class="teacher-lesson-item">
					<div class="teacher-lesson-pic f-img-box">
						<img src="../index/collection-pic.png">
						<div class="teacher-lesson-rate">进度10-1</div>
					</div>
					<div class="teacher-lesson-content">
						<div class="teacher-lesson-title o1">聆听心声，寻找美的事物</div>
						<div class="teacher-lesson-info f-cb">
							<div class="teacher-lesson-num">200人报名</div>
							<div class="teacher-lesson-score">8.0分</div>
						</div>
					</div>
				</li>-->
				<li class="teacher-lesson-item" v-for="item in classes" @click="$router.push('/lesson-detail/'+item.id)">
					<div class="teacher-lesson-pic f-img-box">
						<img :src="item.cover_img">
						<!--<div class="teacher-lesson-rate">进度10-1</div>-->
					</div>
					<div class="teacher-lesson-content">
						<div class="teacher-lesson-title o1">{{item.course_title}}</div>
						<div class="teacher-lesson-info f-cb">
							<div class="teacher-lesson-num">{{item.baoming_num}}人报名</div>
							<!--<div class="teacher-lesson-score">8.0分</div>-->
						</div>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return {
				classes:[]
			}
		},
		created(){
			this.$api.get("",{
				api:"/v1/user/read",
				id:this.$route.params.id,
				user_type:this.tools.getStorage("user_type")
			},(res)=>{
				var data=res.data;
				this.classes=data.classes;
			})
		}
	}
</script>

<style>
	.teacher-lesson-item{
		margin-top:0.426rem;
		padding:0 0.4rem;
	}
	.teacher-lesson-pic{
		position: relative;
		float:left;
		width:3.706rem;
		height:2.106rem;
		border-radius: 0.106rem;
	}
	.teacher-lesson-rate{
		position: absolute;
		bottom:0;
		left:0;
		width:100%;
		height:0.64rem;
		background: rgba(0,0,0,0.5);
		color:#fff;
		text-align: center;
		line-height: 0.64rem;
		font-size: 0.346rem;
	}
	.teacher-lesson-content{
		float:right;
		padding-top:0.253rem;
		width:5.226rem;
	}
	.teacher-lesson-title{
		color:#333;
		font-size: 0.453rem;
	}
	.teacher-lesson-info{
		margin-top:0.826rem;
		font-size: 0.346rem;
		line-height: 0.346rem;
	}
	.teacher-lesson-num{
		float:left;
		font-size: 0.346rem;
		color:#999;
	}
	.teacher-lesson-score{
		float:right;
		color:#EC6D3A;
	}
</style>



// WEBPACK FOOTER //
// src/components/teacher-lesson/teacher-lesson.vue